import { Component, Inject, OnInit } from '@angular/core';

import { HsgModalDefault, HsgModalDefaultData, HSG_MODAL_DATA, HsgModalRef } from '@hhsg/hsg-asc';
import { ImportTotalUosPatient } from 'src/shared/models/import-total-uos.model';
import { TotalUosImportService } from 'src/shared/services/total-uos-import.service';
import { ShiftBlockService } from 'src/shared/services/shift-block.service';
import { ShiftBlock } from 'src/shared/models/shift-block.model';
import { CostCenter } from 'src/shared/models/cost-center.model';

@Component({
    selector: 'smt-import-total-uos-modal',
    templateUrl: './import-total-uos-modal.component.html',
    styleUrls: ['./import-total-uos-modal.component.scss']
})
export class ImportTotalUosModalComponent extends HsgModalDefault implements OnInit {
    public importedRows: ImportTotalUosPatient[];
    public loading: boolean;

	constructor(
        private _totalUosService: TotalUosImportService,
        private _shiftBlockService: ShiftBlockService,
		public modalRef: HsgModalRef<HsgModalDefault>,
        @Inject(HSG_MODAL_DATA) public data: HsgModalDefaultData) {
        super(modalRef, data);
    }

    routerLink() {
        return ['/workflow/planner/'];
    }

    async ngOnInit() {
        this.loading = true;
        let data = this.data as any;
        let shiftBlock = data.shiftBlock as ShiftBlock;
        let workflowDate = data.workflowDate as string;
        let costCenter = data.costCenter as CostCenter;
        let isFirstShiftBlock = data.isFirstShiftBlock as boolean;
        let isLastShiftBlock = data.isLastShiftBlock as boolean;
        let startDate = this._shiftBlockService.getShiftBlockStartTime(shiftBlock, workflowDate).toDate();
        if(isFirstShiftBlock){
            startDate.setHours(0);
        }
        let endDate = this._shiftBlockService.getShiftBlockEndTime(shiftBlock, workflowDate).toDate();        
        if(isLastShiftBlock){
            let doesLatestShiftBlockSpanMultipleDays = shiftBlock.endHour < shiftBlock.startHour;
            doesLatestShiftBlockSpanMultipleDays ? endDate.setHours(shiftBlock.endHour) : endDate.setHours(24);            
        }
        this.importedRows = await this._totalUosService.getTotalUosImportRawData(costCenter.id, startDate, endDate);
        this.loading = false;
    }
}
